
let states = [
  {"title":"Alaska","abbr":"AK"},
  {"title":"Alabama","abbr":"AL"},
  {"title":"Arkansas","abbr":"AR"},
  {"title":"American Samoa","abbr":"AS"},
  {"title":"Arizona","abbr":"AZ"},
  {"title":"California","abbr":"CA"},
  {"title":"Colorado","abbr":"CO"},
  {"title":"Connecticut","abbr":"CT"},
  {"title":"District of Colombia","abbr":"DC"},
  {"title":"Delaware","abbr":"DE"},
  {"title":"Florida","abbr":"FL"},
  {"title":"Georgia","abbr":"GA"},
  {"title":"Guam","abbr":"GU"},
  {"title":"Hawaii","abbr":"HI"},
  {"title":"Iowa","abbr":"IA"},
  {"title":"Idaho","abbr":"ID"},
  {"title":"Illinois","abbr":"IL"},
  {"title":"Indiana","abbr":"IN"},
  {"title":"Kansas","abbr":"KS"},
  {"title":"Kentucky","abbr":"KY"},
  {"title":"Louisiana","abbr":"LA"},
  {"title":"Massachusetts","abbr":"MA"},
  {"title":"Maryland","abbr":"MD"},
  {"title":"Maine","abbr":"ME"},
  {"title":"Michigan","abbr":"MI"},
  {"title":"Minnesota","abbr":"MN"},
  {"title":"Missouri","abbr":"MO"},
  {"title":"Northern Mariana Islands", "abbr":"MP"},
  {"title":"Mississippi","abbr":"MS"},
  {"title":"Montana","abbr":"MT"},
  {"title":"North Carolina","abbr":"NC"},
  {"title":"North Dakota","abbr":"ND"},
  {"title":"Nebraska","abbr":"NE"},
  {"title":"New Hampshire","abbr":"NH"},
  {"title":"New Jersey","abbr":"NJ"},
  {"title":"New Mexico","abbr":"NM"},
  {"title":"Nevada","abbr":"NV"},
  {"title":"New York","abbr":"NY"},
  {"title":"Ohio","abbr":"OH"},
  {"title":"Oklahoma","abbr":"OK"},
  {"title":"Oregon","abbr":"OR"},
  {"title":"Pennsylvania","abbr":"PA"},
  {"title":"Puerto Rico","abbr":"PR"},
  {"title":"Rhode Island","abbr":"RI"},
  {"title":"South Carolina","abbr":"SC"},
  {"title":"South Dakota","abbr":"SD"},
  {"title":"Tennessee","abbr":"TN"},
  {"title":"Trust Territories","abbr":"TT"},
  {"title":"Texas","abbr":"TX"},
  {"title":"Utah","abbr":"UT"},
  {"title":"Virginia","abbr":"VA"},
  {"title":"Virgin Islands","abbr":"VI"},
  {"title":"Vermont","abbr":"VT"},
  {"title":"Washington","abbr":"WA"},
  {"title":"Wisconsin","abbr":"WI"},
  {"title":"West Virginia","abbr":"WV"},
  {"title":"Wyoming","abbr":"WY"}
]
let abbrs = []
let titles = []
let lowers = []

for (let s of states){
  s.lower = s.title.toLowerCase()
  abbrs.push(s.abbr)
  titles.push(s.title)
  lowers.push(s.lower)
}

function search(term, attr){
  attr = attr?attr:'lower'
  if (attr === 'lower'){
    term = term.toLowerCase()
  }
  let ret = []
  for (let s of states){
    if (s[attr].startsWith(term)){
      ret = [s, ...ret]
    } else if (s[attr].includes(term)){
      ret = [...ret, s]
    }
  }
  return ret
}

export default {
  states,
  abbrs,
  titles,
  lowers,
  search
}




// WEBPACK FOOTER //
// ./src/lib/usStates.js